const CONSTANTS = {
  DEBUG_ENABLED: false,
  QUERY_SELECTORS: {
    ALERT_BANNER: ".alert-banner-wrapper",
  },
  CLASSNAMES: {
    IS_ACTIVE: "is-active",
  },
  CSS_VARS: {
    ALERT_BANNER_HEIGHT: "--alert-banner-height",
  },
};

export default () => {
  function handleResizeScroll() {
    const foundAlertBanner = document.querySelector(
      CONSTANTS.QUERY_SELECTORS.ALERT_BANNER
    );

    if (foundAlertBanner) {
      const bannerHeight = foundAlertBanner.offsetHeight;
      const scrollY = window.scrollY;
      const adjustedBannerHeight = Math.max(bannerHeight - scrollY, 0);

      if (CONSTANTS.DEBUG_ENABLED) {
        console.log("alert banner found");
        `Class applied: ${foundAlertBanner.classList.contains(
          CONSTANTS.CLASSNAMES.IS_ACTIVE
        )}`,
          `Adjusted height: ${adjustedBannerHeight}px`;
      }

      if (CONSTANTS.DEBUG_ENABLED) {
        console.log(
          `scrollY: ${scrollY}, bannerHeight: ${bannerHeight}, adjustedBannerHeight: ${adjustedBannerHeight}`
        );
      }

      document.documentElement.style.setProperty(
        CONSTANTS.CSS_VARS.ALERT_BANNER_HEIGHT,
        `${adjustedBannerHeight}px`
      );
    }
  }

  handleResizeScroll();
  window.addEventListener("resize", handleResizeScroll, { passive: true });
  window.addEventListener("scroll", handleResizeScroll, { passive: true });
};
